/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Button, Loader, Text, Title } from '@mantine/core';
import { useState } from 'react';
import { closeAllModals } from '@mantine/modals';
import { useNavigate } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { MixpanelS } from '../../Service/MixpanelS';
import { ConstantS } from '../../Service/ConstantS';
import { EventS } from '../../Service/EventS';
import { toUTC } from '../../Utils/dateUtils';
import { saveContact } from '../../Service/restapi/contactService';

const ExtendedOnboarding = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setError] = useState<string>();

  const save = async () => {
    let tmpContact: any;

    let customerId;
    tmpContact = {
      firstName: 'Max',
      lastName: 'Mustermann',
      contactType: 'PRIVATE',
    };

    if (errorMessage) {
      setError(undefined);
    }
    setLoading(true);
    const resp = await saveContact(tmpContact);
    if (resp.ok) {
      const newContact = await resp.json();
      customerId = newContact.id;
    }

    const newEvent = await EventS.createEventV2({
      customerId,
      dates: [toUTC(new Date())],
      name: 'Onboarding-Event',
    });
    if (newEvent) {
      MixpanelS.track(ConstantS.TrackingEvents.FirstEventCreated);
      const { id: eventId } = newEvent;
      closeAllModals();
      navigate(`/events/${eventId}/details`);
    }
  };

  return (
    <>
      <div style={{ textAlign: 'center' }}>
        <Title order={4}>Online-Verträge, statt Papierkram.</Title>
        <Text size="sm" color={'dimmed'}>
          Deine Kunden können deine Verträge demnächst online unterzeichnen. Schau selbst... wir haben ein Beispiel für Dich vorbereitet:
        </Text>
        <Button
          id={'create-first-event'}
          fullWidth
          mt="xl"
          mb="sm"
          onClick={save}
          disabled={loading}
          leftIcon={loading && <Loader size="xs" />}
        >
          Beispiel-Online-Vertrag zeigen
        </Button>
      </div>
    </>
  );
};

export default ExtendedOnboarding;
